<form [formGroup]="parentForm">
  <div class="container" formGroupName="templates">
    <mat-form-field class="hint">
      <input matInput placeholder="Template ID" autocomplete="off" formControlName="templateId" required />
      <mat-hint>The base id for the templates for this post type</mat-hint>
    </mat-form-field>
    <div formGroupName="hydrators">
      <h3>Hydration Options</h3>
      <span>
        These options will allow identifiers on the event data to be inflated into entities that will be accessible in
        the template
      </span>
      <div class="container" formGroupName="accountGroups">
        <mat-checkbox formControlName="checked" (change)="hydratorChecked('accountGroups', $event.checked)">
          Account Groups
        </mat-checkbox>
        <div
          class="container"
          formGroupName="params"
          *ngIf="parentForm.get('templates').get('hydrators').get('accountGroups').get('checked').value"
        >
          <mat-form-field class="hint">
            <input
              matInput
              placeholder="Account Group Id(s)"
              autocomplete="off"
              formControlName="accountGroupIds"
              required
            />
            <mat-hint>The path to the account group id or list of account group ids on the event</mat-hint>
          </mat-form-field>
          <mat-form-field class="hint">
            <input
              matInput
              placeholder="Inflated Property Name"
              autocomplete="off"
              formControlName="inflatedPropertyName"
              required
            />
            <mat-hint>
              The name that the inflated list of account groups will be available under in the template
            </mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="container" formGroupName="apps">
        <mat-checkbox formControlName="checked" (change)="hydratorChecked('apps', $event.checked)">Apps</mat-checkbox>
        <div
          class="container"
          formGroupName="params"
          *ngIf="parentForm.get('templates').get('hydrators').get('apps').get('checked').value"
        >
          <mat-form-field class="hint">
            <input matInput placeholder="App Key(s)" autocomplete="off" formControlName="appKeys" required />
            <mat-hint>
              The path to the app key or list of app keys on the event (a key must have an `app_id`, and optionally an
              `edition_id`)
            </mat-hint>
          </mat-form-field>
          <mat-form-field class="hint">
            <input matInput placeholder="Partner Id" autocomplete="off" formControlName="partnerId" required />
            <mat-hint>The path to the partner id on the event</mat-hint>
          </mat-form-field>
          <mat-form-field class="hint">
            <input matInput placeholder="Market Id" autocomplete="off" formControlName="marketId" />
            <mat-hint>The path to the market id on the event</mat-hint>
          </mat-form-field>
          <mat-form-field class="hint">
            <input
              matInput
              placeholder="Inflated Property Name"
              autocomplete="off"
              formControlName="inflatedPropertyName"
              required
            />
            <mat-hint>The name that the inflated list of apps will be available under in the template</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="container" formGroupName="packages">
        <mat-checkbox formControlName="checked" (change)="hydratorChecked('packages', $event.checked)">
          Packages
        </mat-checkbox>
        <div
          class="container"
          formGroupName="params"
          *ngIf="parentForm.get('templates').get('hydrators').get('packages').get('checked').value"
        >
          <mat-form-field class="hint">
            <input matInput placeholder="Package Id(s)" autocomplete="off" formControlName="packageIds" required />
            <mat-hint>The path to the package id or list of package ids on the event</mat-hint>
          </mat-form-field>
          <mat-form-field class="hint">
            <input
              matInput
              placeholder="Inflated Property Name"
              autocomplete="off"
              formControlName="inflatedPropertyName"
              required
            />
            <mat-hint>The name that the inflated list of packages will be available under in the template</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="container" formGroupName="branding">
        <mat-checkbox formControlName="checked" (change)="hydratorChecked('branding', $event.checked)">
          Branding
        </mat-checkbox>
        <div
          class="container"
          formGroupName="params"
          *ngIf="parentForm.get('templates').get('hydrators').get('branding').get('checked').value"
        >
          <mat-form-field class="hint">
            <input matInput placeholder="Partner Id" autocomplete="off" formControlName="partnerId" required />
            <mat-hint>The path to the partner id on the event</mat-hint>
          </mat-form-field>
          <mat-form-field class="hint">
            <input matInput placeholder="Market Id" autocomplete="off" formControlName="marketId" />
            <mat-hint>The path to the market id on the event</mat-hint>
          </mat-form-field>
          <mat-form-field class="hint">
            <input
              matInput
              placeholder="Inflated Property Name"
              autocomplete="off"
              formControlName="inflatedPropertyName"
              required
            />
            <mat-hint>The name that the inflated branding will be available under in the template</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="container" formGroupName="users">
        <mat-checkbox formControlName="checked" (change)="hydratorChecked('users', $event.checked)">Users</mat-checkbox>
        <div
          class="container"
          formGroupName="params"
          *ngIf="parentForm.get('templates').get('hydrators').get('users').get('checked').value"
        >
          <mat-form-field class="hint">
            <input matInput placeholder="User Id(s)" autocomplete="off" formControlName="userIds" required />
            <mat-hint>The path to the user id or list of user ids on the event</mat-hint>
          </mat-form-field>
          <mat-form-field class="hint">
            <input
              matInput
              placeholder="Inflated Property Name"
              autocomplete="off"
              formControlName="inflatedPropertyName"
              required
            />
            <mat-hint>The name that the inflated list of users will be available under in the template</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="container" formGroupName="salesActivities">
        <mat-checkbox formControlName="checked" (change)="hydratorChecked('salesActivities', $event.checked)">
          Sales Activities
        </mat-checkbox>
        <div
          class="container"
          formGroupName="params"
          *ngIf="parentForm.get('templates').get('hydrators').get('salesActivities').get('checked').value"
        >
          <mat-form-field class="hint">
            <input
              matInput
              placeholder="Sales Activity Key(s)"
              autocomplete="off"
              formControlName="salesActivityKeys"
              required
            />
            <mat-hint>
              The path to the sales activity key or sales activity keys on the event (a key must have a
              `sales_activity_id` and `business_id`)
            </mat-hint>
          </mat-form-field>
          <mat-form-field class="hint">
            <input
              matInput
              placeholder="Inflated Property Name"
              autocomplete="off"
              formControlName="inflatedPropertyName"
              required
            />
            <mat-hint>
              The name that the inflated list of sales activities will be available under in the template
            </mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="container" formGroupName="partnerConfig">
        <mat-checkbox formControlName="checked" (change)="hydratorChecked('partnerConfig', $event.checked)">
          Partner Config
        </mat-checkbox>
        <div
          class="container"
          formGroupName="params"
          *ngIf="parentForm.get('templates').get('hydrators').get('partnerConfig').get('checked').value"
        >
          <mat-form-field class="hint">
            <input matInput placeholder="Partner Id" autocomplete="off" formControlName="partnerId" required />
            <mat-hint>The path to the partner id on the event</mat-hint>
          </mat-form-field>
          <mat-form-field class="hint">
            <input matInput placeholder="Market Id" autocomplete="off" formControlName="marketId" />
            <mat-hint>The path to the market id on the event</mat-hint>
          </mat-form-field>
          <mat-form-field class="hint">
            <input
              matInput
              placeholder="Inflated Property Name"
              autocomplete="off"
              formControlName="inflatedPropertyName"
              required
            />
            <mat-hint>The name that the inflated partner config will be available under in the template</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="container" formGroupName="task">
        <mat-checkbox formControlName="checked" (change)="hydratorChecked('task', $event.checked)">Tasks</mat-checkbox>
        <div
          class="container"
          formGroupName="params"
          *ngIf="parentForm.get('templates').get('hydrators').get('task').get('checked').value"
        >
          <mat-form-field class="hint">
            <input matInput placeholder="Task Key(s)" autocomplete="off" formControlName="taskKeys" required />
            <mat-hint>
              The path to the task key or list of task keys on the event (a key must have a `namespace`, `parent_path`
              and `task_id`)
            </mat-hint>
          </mat-form-field>
          <mat-form-field class="hint">
            <input
              matInput
              placeholder="Inflated Property Name"
              autocomplete="off"
              formControlName="inflatedPropertyName"
              required
            />
            <mat-hint>The name that the inflated list of tasks will be available under in the template</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</form>
<p>
  These HTML templates will be sanitized by the
  <a href="https://angular.io/api/platform-browser/DomSanitizer" target="_blank">Angular DomSanitizer</a>
  .
</p>
<p>
  The styles template will be trusted and bypass security, so please do not include any variables that could have user
  input in them.
</p>
<mat-tab-group animationDuration="0ms">
  <mat-tab label="Full Template">
    <div class="tab-container">
      <div class="left-pane">
        <mat-tab-group animationDuration="0ms">
          <mat-tab label="Template">
            <div class="editor">
              <ace
                [mode]="'html'"
                [theme]="'dawn'"
                [value]="fullHTML$ | async"
                (valueChange)="updateFullHTML($event)"
              ></ace>
            </div>
          </mat-tab>
          <mat-tab label="Styles">
            <div class="editor">
              <ace
                [mode]="'html'"
                [theme]="'dawn'"
                [value]="styles$ | async"
                (valueChange)="updateStyles($event)"
              ></ace>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
      <mat-divider [vertical]="true" />
      <div class="right-pane">
        <div class="error">
          <mat-card appearance="outlined" *ngIf="previewStylesError$ | async as error">
            <mat-icon>error_outline</mat-icon>
            {{ error }}
          </mat-card>
        </div>
        <div class="error">
          <mat-card appearance="outlined" *ngIf="previewFullError$ | async as error">
            <mat-icon>error_outline</mat-icon>
            {{ error }}
          </mat-card>
        </div>
        <!--        This is copied from sales-common in the frontend
        TODO:should import the component from there instead when Angular is update-->
        <mat-card appearance="outlined" class="stream-item-container">
          <div class="stream-item-main-section">
            <div class="stream-item-icon">
              <mat-icon>all_inclusive</mat-icon>
            </div>
            <div class="stream-item-body">
              <div [innerHTML]="previewStyles$ | async"></div>
              <div class="body" [innerHTML]="previewFullHTML$ | async" #body></div>
              <div class="stream-item-footer">
                <span>{{ exampleDate | date: 'MMM dd, y - h:mm a' }} ({{ fromNow(exampleDate) }})</span>
              </div>
            </div>
          </div>
        </mat-card>
        <!-- end of copied sales-common post-->
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Compact Template">
    <div class="tab-container">
      <div class="left-pane">
        <div class="editor">
          <ace
            [mode]="'html'"
            [theme]="'dawn'"
            [value]="compactHTML$ | async"
            (valueChange)="updateCompactHTML($event)"
          ></ace>
        </div>
      </div>
      <mat-divider [vertical]="true" />
      <div class="right-pane">
        <div class="error">
          <mat-card appearance="outlined" *ngIf="previewCompactError$ | async as error">
            <mat-icon>error_outline</mat-icon>
            {{ error }}
          </mat-card>
        </div>
        <!--        This is copied from sales-common in the frontend
        TODO:should import the component from there instead when Angular is update-->
        <div class="compact-post">
          <div class="stream-item-icon">
            <mat-icon>all_inclusive</mat-icon>
          </div>
          <div>
            <div class="compact-body" [innerHTML]="previewCompactHTML$ | async" #body></div>
            <div class="stream-item-footer">
              <span>{{ exampleDate | date: 'MMM dd, y - h:mm a' }} ({{ fromNow(exampleDate) }})</span>
            </div>
          </div>
        </div>
        <!-- end of copied sales-common post-->
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Sample Data">
    <div class="tab-container">
      <div class="left-pane">
        <div class="editor">
          <ace
            [mode]="'json'"
            [theme]="'dawn'"
            [value]="sampleData$ | async"
            (valueChange)="updateSampleData($event)"
          ></ace>
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
